<app-bottom-sheet #sheet ariaLabel="مرتب‌سازی دارایی‌ها">
	<ng-template #body>
		<div class="flex flex-col gap-2 pb-3" data-cy="portfolio-sort-content">
			<h3 class="flex items-center justify-center gap-1 pb-2.5 text-sm font-bold text-gray-900">
				<ui-icon width="20" height="20" iconName="sort" aria-hidden="true" />
				مرتب‌سازی
			</h3>

			<!-- جهت مرتب‌سازی — descending first, so it sits on the right in this RTL
				layout as the handoff has it. -->
			<!-- `name` rather than `label`: the design shows no caption above the
				toggle, and `label` would render one. `ui-toggle-button` falls back to
				`name` for the group's accessible name, so the phrase goes there. -->
			<!-- The group's track is `inline-flex`, so it is only as wide as its two
				options; the handoff has it filling the row. Widened from here rather
				than through a new input on the shared component — its options already
				carry `flex-1 basis-0`, so a full-width track splits evenly between
				them. -->
			<ui-toggle-button
				name="جهت مرتب‌سازی"
				size="md"
				class="[&_[role=radiogroup]]:w-full"
				data-cy="portfolio-sort-direction"
				[options]="directionOptions()"
				[selectedValue]="activeDirection()"
				(valueChange)="onDirectionChange($event)" />

			<!-- معیارهای مرتب‌سازی. The rows run edge to edge — `-mx-4` cancels the
				sheet panel's own padding, which `px-4` then restores on the labels —
				so the selected row's fill and the dividers reach both edges.

				A pressed-button group rather than a radiogroup: the design-system button
				owns its own `<button>`, so `role="radio"` could only land on the wrapper
				around it, with a focusable control inside a radio. `aria-pressed` says
				the same thing about a control that is itself the button. The row's fill
				and divider sit on that wrapper, which is as wide as the row. -->
			<div class="-mx-4 flex flex-col" role="group" aria-label="معیار مرتب‌سازی">
				@for (row of criterionRows(); track row.criterion; let first = $first) {
					<ui-button
						variant="ghost"
						size="lg"
						shape="square"
						class="w-full"
						extraButtonClasses="w-full justify-between px-4 text-gray-900 hover:text-gray-900"
						[class.border-t]="!first"
						[class.border-stroke-100]="!first"
						[class.bg-gray-050]="row.selected"
						[ariaPressed]="row.selected"
						[attr.data-cy]="'portfolio-sort-criterion-' + row.criterion"
						(clicked)="onCriterionClick(row.criterion)">
						<span class="flex w-full items-center justify-between">
							<span>{{ row.label }}</span>
							@if (row.selected) {
								<ui-icon
									width="18"
									height="18"
									class="text-green-500"
									iconName="check"
									aria-hidden="true" />
							}
						</span>
					</ui-button>
				}
			</div>
		</div>
	</ng-template>
</app-bottom-sheet>
